import { createReducer, isFetched, isFetching } from "../../utils/reducer"
import { DASHBOARD_SET, DASHBOARD_REQUEST, DASHBOARD_REQUEST_DONE } from "../actions/dashboardActions"

const initialState = {
	isFetching: true,
	data: {
		total_questions_completed: 0,
		total_questions: 0,
		courses_progress: [],
		streak_days: 0,
		last_activity: null,
	},
}

export const setDashboard = (state, data) => {
	return { ...state, data: data }
}

export default createReducer(initialState, {
	[DASHBOARD_SET]: setDashboard,
	[DASHBOARD_REQUEST]: isFetching,
	[DASHBOARD_REQUEST_DONE]: isFetched,
})
